import {
  ApiResponse,
  LegalDocument,
  LegalDocumentListResponse,
  LegalDocumentFilters,
  CreateLegalDocumentRequest,
  UpdateLegalDocumentRequest,
  DocumentAcceptanceStatsResponse,
  DocumentAcceptanceUsersResponse,
  LegalDocumentSlugsResponse,
} from '@mygate/common';
import { api } from './api';

class LegalDocumentService {
  async list(filters?: LegalDocumentFilters): Promise<ApiResponse<LegalDocumentListResponse>> {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, String(value));
        }
      });
    }
    const queryString = params.toString();
    const endpoint = queryString ? `/api/staff/legal-documents?${queryString}` : '/api/staff/legal-documents';
    return await api.get<LegalDocumentListResponse>(endpoint);
  }

  async getById(id: string): Promise<ApiResponse<LegalDocument>> {
    return await api.get<LegalDocument>(`/api/staff/legal-documents/${id}`);
  }

  async create(data: CreateLegalDocumentRequest): Promise<ApiResponse<LegalDocument>> {
    return await api.post<LegalDocument>('/api/staff/legal-documents', data);
  }

  async update(id: string, data: UpdateLegalDocumentRequest): Promise<ApiResponse<LegalDocument>> {
    return await api.put<LegalDocument>(`/api/staff/legal-documents/${id}`, data);
  }

  async publish(id: string): Promise<ApiResponse<LegalDocument>> {
    return await api.post<LegalDocument>(`/api/staff/legal-documents/${id}/publish`);
  }

  async archive(id: string): Promise<ApiResponse<LegalDocument>> {
    return await api.post<LegalDocument>(`/api/staff/legal-documents/${id}/archive`);
  }

  async getStats(id: string): Promise<ApiResponse<DocumentAcceptanceStatsResponse>> {
    return await api.get<DocumentAcceptanceStatsResponse>(`/api/staff/legal-documents/${id}/stats`);
  }

  async getSlugs(): Promise<ApiResponse<LegalDocumentSlugsResponse>> {
    return await api.get<LegalDocumentSlugsResponse>('/api/staff/legal-documents/slugs');
  }

  async getAcceptanceUsers(
    id: string,
    filter: 'accepted' | 'pending' | 'all' = 'all',
    page = 1,
    limit = 50,
  ): Promise<ApiResponse<DocumentAcceptanceUsersResponse>> {
    return await api.get<DocumentAcceptanceUsersResponse>(
      `/api/staff/legal-documents/${id}/acceptances?filter=${filter}&page=${page}&limit=${limit}`,
    );
  }

  getAcceptanceExportUrl(id: string): string {
    return `/api/staff/legal-documents/${id}/acceptances/export`;
  }
}

export const legalDocumentService = new LegalDocumentService();
